var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    y: 0,
    width: 30,
    height: 30
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.2,9.9c-.6.6-1.6.5-1,1.7s2.2,2.6,1.8,4.4-1.4.3-1.9.4c-.8.1-.1,1,0,1.4,0,.6,0,1.3,0,1.9s.3.8.2,1.2c-.1.1-2.1-.6-2.4-.7-.9-.2-2.8.2-2-1.4-.2-.3-.8-.4-1-.1s.5,1-.4,1.1-.6-.7-.9-.9c-.6-.3-1.1.5-1.2,1-.2,1,.4,1.5-.9,1.8s-.9,0-1,.2.9.8.3,1.4c-1,.9-1.7-1.9-2.2-2.4s-.7-.4-1.1-.7-.8-1-1.1-.9c-.6,0-.2.6,0,.9.4.4,1.9,1.1,2,1.4s0,.2,0,.3c-.4,0-.4.2-.4.5-.7.2-.8-.5-1.2-.9s-.5-.3-.7-.4c-.4-.3-.8-1.1-1.2-1.1-.5.3-1.8.3-2.2.5s-.6.9-.8,1.1-.5.4-.7.7-.2.5-.4.8c-.6.9-2.3.9-2.9,0s-.7-2.8.6-3,2.4.8,2.2-.7-.8-1.1-.6-1.5,1.2-.4,1.5-.6c1-.5,2.2-2.1,3.2-2.1s1.4.4,2.3.2,2.5-1.5,2.2-2.4-1-.5-1.1-1c0-.5,1-.8.7-1.7-.5-.5-1.7.5-2,1.1s0,.9,0,1.5-.2,1.3-.4,1.4c-.7.4-.8-1-1.5-1.1s-.9.8-1.8.4c-.1-.2-.1-.9,0-1.1.2-1,1.2-1.1,1.8-1.7s.6-.9.9-1.3c.7-.8,2.3-1.4,3.4-1.2s1.9,1.6,3.2,1.7c1.9.2,2.7-.6,4.2-.9s.6,0,.9,0c.8-.1,3-.7,3.5-.3s0,1-.2,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,17.2c0-.2.2-.5.1-.7s-.4-.1-.3-.3c1.1-.8-.8-1.6-.2-2.5s1,.4.9.9l1.5,1.7c-.3.7-1.3,1-2,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1,9.9c.3,0,.5.3.8.3.4,0,.8-.4,1.5-.2,1.1.3-.6,1.4-1.1,1.4s-1.2-.1-1.3-.2c-.5-.3-.3-.7-.3-1.1,0,0,.3-.2.4-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6,14.8c.4-.1.7,0,.8.4-.2.8-.6,1.8-1.6,1.4s0-.4.1-.6c.1-.4,0-1,.6-1.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEur);
export default __webpack_public_path__ + "static/media/EUR.c58e14496b0e49e13c67db40c745ed29.svg";
export { ForwardRef as ReactComponent };